<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="dialogColor" dark
        ><h4>
          Seleccione un rango de fecha e ingrese el numero de la orden de compra
        </h4></v-toolbar
      >
      <v-card-text>
        <v-container>
          <DateRangePicker @dates-selected="handleDatesSelected" />
          <v-text-field
            v-model="ordenCompraModel"
            label="Orden Compra"
            dense
            type="number"
            prepend-icon="mdi-numeric"
          ></v-text-field>
        </v-container>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          title="Finalizar Parcialmente"
          color="blue"
          dark
          @click="generarCertificadoManoObra()"
          ><v-icon>mdi-clock-end</v-icon>Generar Certificado</v-btn
        >
        <v-btn title="Cerrar" color="red" dark @click="dialog = false"
          ><v-icon>mdi-close-circle</v-icon>Cerrar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import DateRangePicker from "@/components/DateRangePicker.vue";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
//import { component } from "vue/types/umd";
export default {
  components: {
    DateRangePicker,
  },

  data: () => ({
    selectedDates: [],
    dialog: false,
    dialogColor: "",
    datosTarea: [],
    observacionModel: null,
  }),

  methods: {
    handleDatesSelected(dates) {
      this.selectedDates = dates;
      console.log("El rango de fecha es:");
      console.log(this.selectedDates);
      this.recuperarTareas();
    },

    abrirDialog() {
      console.log("Los items son: ");
      this.dialog = true;
      this.dialogColor = "red";
      console.log("Los datos del usuario son: ");
      console.log(this.$store.getters.usuario);
    },

    async generarCertificadoManoObra() {
      this.url =
        this.$store.getters.urlBase +
        "Reporte/recuperarCertificadoMensualManoObra";

      const datos = {
        fechas: this.selectedDates,
        ordenCompra: parseInt(this.ordenCompraModel),
      };

      console.log("Los parametros son:");
      console.log(datos);

      axios
        .get(this.url, {
          params: datos,
          paramsSerializer: (params) => {
            const partes = [];
            Object.entries(params).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                value.forEach((v) => {
                  partes.push(`${key}=${encodeURIComponent(v)}`);
                });
              } else {
                partes.push(`${key}=${encodeURIComponent(value)}`);
              }
            });
            return partes.join("&");
          },
        })
        .then((response) => {
          console.log("La respuesta de generar certificado es: ");
          console.log(response.data.value);

          this.generarPDF(response.data.value);
        })
        .catch((error) => {
          console.error("Error al generar certificado: ", error);
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ocurrió un error al generar el certificado",
            1,
            "red",
            "Aviso",
          );
        });
    },

    convertirFecha(fecha) {
      const [anio, mes, dia] = fecha.split("-");
      return `${dia}/${mes}/${anio}`;
    },

    generarPDF(datos) {
      // Documento en orientación horizontal (landscape) porque son varias columnas
      const doc = new jsPDF({ orientation: "landscape" });

      // Título
      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      doc.text(
        "Certificado de Mano de Obra (" +
          this.convertirFecha(this.selectedDates[0]) +
          " al " +
          this.convertirFecha(this.selectedDates[1]) +
          ")",
        doc.internal.pageSize.getWidth() / 2,
        15,
        {
          align: "center",
        },
      );

      let totalGeneral = 0;

      // Armamos las filas calculando los subtotales y el total
      const filas = datos.map((item) => {
        const subTotalNormal = item.cantidadNormal * item.precioNormal;
        const subTotalEspecial = item.cantidadEspecial * item.precioEspecial;
        const total = subTotalNormal + subTotalEspecial;

        totalGeneral += total;

        return [
          item.codigoManoObra,
          item.descripcionManoObra,
          item.cantidadNormal,
          item.cantidadEspecial,
          item.precioNormal.toLocaleString("es-AR", {
            minimumFractionDigits: 2,
          }),
          item.precioEspecial.toLocaleString("es-AR", {
            minimumFractionDigits: 2,
          }),
          subTotalNormal.toLocaleString("es-AR", { minimumFractionDigits: 2 }),
          subTotalEspecial.toLocaleString("es-AR", {
            minimumFractionDigits: 2,
          }),
          total.toLocaleString("es-AR", { minimumFractionDigits: 2 }),
        ];
      });

      // Tabla
      autoTable(doc, {
        startY: 22,
        head: [
          [
            "Codigo Mano de Obra",
            "Descripcion",
            "Cantidad Normal",
            "Cantidad Especial",
            "Precio Normal",
            "Precio Especial",
            "Sub Total Normal",
            "Sub Total Especial",
            "Total",
          ],
        ],
        body: filas,
        styles: { fontSize: 8, halign: "center" },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: 0,
          fontStyle: "bold",
        },
        theme: "grid",
      });

      // Total general al final de la tabla
      const finalY = doc.lastAutoTable.finalY + 10;
      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      doc.text(
        `Total General: ${totalGeneral.toLocaleString("es-AR", {
          minimumFractionDigits: 2,
        })}`,
        doc.internal.pageSize.getWidth() - 14,
        finalY,
        { align: "right" },
      );

      // Guardamos / descargamos el PDF
      doc.save("CertificadoManoObra.pdf");
    },

    suspender() {
      this.url = this.$store.getters.urlBase + "Task/suspenderTarea";

      const tarea = {
        idTarea: this.datosTarea.idTarea,
        observacion: this.observacionModel,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los parametros son:");
      console.log(tarea);

      axios.post(this.url, tarea).then((response) => {
        console.log("Las respuesta de ingresa cuadrilla es: ");
        console.log(response.data);
        if (response.data == false) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ya existe un remito con el mismo numero",
            1,
            "red",
            "Aviso",
          );
        } else {
          this.$refs.dialogCuadrilla.abrirCuadrillaDialog(
            "Operacion Exitosa",
            1,
            "green",
            "Ok",
          );
        }
        this.otMantenimiento = response.data;
      });
    },
  },
};
</script>
